/**
 * @generated SignedSource<<d96bacf99b2b4d5ee68b89e33aed3c26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranscriptPanelRelabelSpeakerWithoutUserMutation$variables = {
  currentLabel: string;
  meetingRecordingId: string;
  newLabel: string;
};
export type TranscriptPanelRelabelSpeakerWithoutUserMutation$data = {
  readonly relabelRecordingSpeaker: {
    readonly meetingRecording: {
      readonly id: string;
      readonly transcript: any | null;
      readonly " $fragmentSpreads": FragmentRefs<"TranscriptModalContentStats" | "TranscriptPanel_recordingParticipants">;
    };
  } | null;
};
export type TranscriptPanelRelabelSpeakerWithoutUserMutation = {
  response: TranscriptPanelRelabelSpeakerWithoutUserMutation$data;
  variables: TranscriptPanelRelabelSpeakerWithoutUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currentLabel"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "meetingRecordingId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "newLabel"
},
v3 = [
  {
    "kind": "Variable",
    "name": "currentLabel",
    "variableName": "currentLabel"
  },
  {
    "kind": "Variable",
    "name": "meetingRecordingId",
    "variableName": "meetingRecordingId"
  },
  {
    "kind": "Variable",
    "name": "newLabel",
    "variableName": "newLabel"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transcript",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTopUser",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "RecordingParticipant",
  "kind": "LinkedField",
  "name": "allRelevantParticipants",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TranscriptPanelRelabelSpeakerWithoutUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "RelabelRecordingSpeaker",
        "kind": "LinkedField",
        "name": "relabelRecordingSpeaker",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "meetingRecording",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TranscriptPanel_recordingParticipants"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TranscriptModalContentStats"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TranscriptPanelRelabelSpeakerWithoutUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "RelabelRecordingSpeaker",
        "kind": "LinkedField",
        "name": "relabelRecordingSpeaker",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "meetingRecording",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isMeetingRecordingInterface"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingCallStart",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingCallEnd",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingRecordedVideoDuration",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MeetingStats",
                    "kind": "LinkedField",
                    "name": "meetingStats",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingStatsUser",
                        "kind": "LinkedField",
                        "name": "userStats",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          (v6/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isGuest",
                            "storageKey": null
                          },
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "absent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalTalkTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "percentage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "joinedAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "leftAt",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "actualStartTime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "actualEndTime",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "MeetingRecording",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MeetingRecording",
                    "kind": "LinkedField",
                    "name": "baseRecording",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "MeetingRecordingClip",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9b26ac5c58ac0228f2764d0187a71a54",
    "id": null,
    "metadata": {},
    "name": "TranscriptPanelRelabelSpeakerWithoutUserMutation",
    "operationKind": "mutation",
    "text": "mutation TranscriptPanelRelabelSpeakerWithoutUserMutation(\n  $meetingRecordingId: ID!\n  $newLabel: String!\n  $currentLabel: String!\n) {\n  relabelRecordingSpeaker(meetingRecordingId: $meetingRecordingId, newLabel: $newLabel, currentLabel: $currentLabel) {\n    meetingRecording {\n      __typename\n      id\n      transcript\n      ...TranscriptPanel_recordingParticipants\n      ...TranscriptModalContentStats\n    }\n  }\n}\n\nfragment TranscriptModalContentStats on MeetingRecording {\n  meetingCallStart\n  meetingCallEnd\n  meetingRecordedVideoDuration\n  meetingStats {\n    userStats {\n      email\n      fullName\n      image\n      isGuest\n      isTopUser\n      absent\n      totalTalkTime\n      percentage\n      joinedAt\n      leftAt\n    }\n    actualStartTime\n    actualEndTime\n  }\n  id\n}\n\nfragment TranscriptPanel_recordingParticipants on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  ... on MeetingRecording {\n    allRelevantParticipants {\n      fullName\n      email\n      image\n      isTopUser\n      user {\n        id\n      }\n    }\n  }\n  ... on MeetingRecordingClip {\n    baseRecording {\n      allRelevantParticipants {\n        fullName\n        email\n        image\n        isTopUser\n        user {\n          id\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "74ef0c95f4700219777f8c1b097d752d";

export default node;
